/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const SERVICE_EMAIL = "service@legalbird.de";

const SERVICE_PHONE_BASE = "221 98651940";
const SERVICE_PHONE = "0" + SERVICE_PHONE_BASE;
const SERVICE_PHONE_INTERNATIONAL = "+49" + SERVICE_PHONE_BASE;
const SERVICE_TIMES = {
  start: 8,
  end: 18,
};
const LAW_FIRM_EMAIL = "anwalt@legalbird-kanzlei.de";
const LAW_FIRM_PHONE = "0221/98651941";
const LAW_FIRM_FAX = "0221/98651949";
const LAW_FIRM_NAME = "Legalbird Rechtsanwälte Rechtsanwalts GmbH";
const LAW_FIRM_ADDRESS = "Im Zollhafen 24";
const LAW_FIRM_POSTAL_CODE = 50678;
const LAW_FIRM_ADDRESS_LOCALITY = "Köln";
const LAW_FIRM_ADDRESS_REGION = "NRW";
const RS_NAME = "Legalbird GmbH";
const RS_ADDRESS = "Im Zollhafen 24";
const RS_POSTAL_CODE = 50678;
const RS_ADDRESS_LOCALITY = "Köln";

const VAT = 0.19;
const VAT_MULTIPLIER = 1.19;
const DOCUMENTS = {
  generic: {
    title: "Dokument",
    titlePossessive: "Ihr Dokument",
    titleArticleDefinite: "das Dokument",
    titleArticleIndefinite: "ein Dokument",
    urlSegment: "",
  },
  alimony: {
    title: "Analyse zum Unterhalt",
    titlePossessive: "Ihre Unterhaltsanalyse",
    titleArticleDefinite: "die Unterhaltsanalyse",
    titleArticleIndefinite: "eine Unterhaltsanalyse",
    urlSegment: "familienrecht/unterhalt",
    documents: "familienrecht/unterhalt/mein-fall",
  },
  death: {
    title: "Dokument zum Erbe / Todesfall",
    titlePossessive: "Ihre Analyse zu Tod und Erbe",
    titleArticleDefinite: "die Analyse zu Tod und Erbe",
    titleArticleIndefinite: "eine Analyse zu Tod und Erbe",
    urlSegment: "familienrecht/todesfall",
    documents: "familienrecht/todesfall/mein-fall",
  },
};

export {
  SERVICE_EMAIL,
  SERVICE_PHONE,
  SERVICE_PHONE_INTERNATIONAL,
  SERVICE_TIMES,
  LAW_FIRM_EMAIL,
  LAW_FIRM_PHONE,
  LAW_FIRM_FAX,
  VAT,
  VAT_MULTIPLIER,
  DOCUMENTS,
  LAW_FIRM_NAME,
  LAW_FIRM_ADDRESS,
  LAW_FIRM_POSTAL_CODE,
  LAW_FIRM_ADDRESS_LOCALITY,
  RS_NAME,
  RS_ADDRESS,
  RS_POSTAL_CODE,
  RS_ADDRESS_LOCALITY,
  LAW_FIRM_ADDRESS_REGION,
};
